<a class="header__account__notifications" [ngClass]="{'header__account__notifications--active': listOpen}"
  (click)="toggleList()">
  <i class="ico-notifications"></i>
  <span class="header__account__notifications__number"
    *ngIf="notifications.length > 0">{{ notifications.length }}</span>
</a>
<div class="header__account__notifications-list" *ngIf="listOpen">
  <ng-container *ngFor="let notification of (notifications ? notifications.slice(0,5) : [])">
    <a class="header__account__notifications-list__link" [routerLink]="routerLink(notification)">
      <span class="header__account__notifications-list__link__date">
        {{ notification.filled | date:'d. M. yyyy HH:mm' }}
      </span>
      <span class="header__account__notifications-list__link__info">
        <ng-container *ngIf="notification.type !== 'appointment' && notification.type !== 'booking'">
          K formuláři:
          <strong>
            {{ notificationTitle(notification) }}
          </strong>
        </ng-container>
        <ng-container *ngIf="notification.type === 'appointment'">
          Ke kalendáři:
          <strong>
            {{ notificationTitle(notification) }}
          </strong>
        </ng-container>
        <ng-container *ngIf="notification.type === 'booking'">
          K rezervaci:
          <strong>
            {{ notificationTitle(notification) }}
          </strong>
        </ng-container>
      </span>
    </a>
  </ng-container>
  <ng-container *ngIf="notifications.length === 0">
    <span
      class="header__account__notifications-list__link header__account__notifications-list__link--more header__account__notifications-list__link--none">
      Žádné nové notifikace.
    </span>
  </ng-container>


  <a *ngIf="notifications.length > 5" routerLink="/forms"
    class="header__account__notifications-list__link header__account__notifications-list__link--more">+
    {{ notifications.length - 5 }} dalších...</a>
</div>
